<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="pay_matrix_list" class="elevation-1 mytable" :search="search">
      <template v-slot:top>
        <v-toolbar class="toolbar" flat color="white">
          <v-toolbar-title>Pay Matrix</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn color="success" outlined rounded v-if="pay_matrix_list.length != 0">
              <download-excel class="mr-2 pb-3 pt-2" :data="pay_matrix_list" :fields="table_fields"
                worksheet="PayRollPayMatrix" name="PayRollPayMatrix.xls">
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn>
          </v-col>
          <v-col sm="6" md="4" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-col>
          <span style="width: 20px"></span>

          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="mb-2 button" v-on="on">Add Pay Matrix</v-btn>
            </template>
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col v-if="editedIndex == -1" cols="12" sm="12" md="12">
                        <v-autocomplete :rules="[(v) => !!v || 'required']" dense v-model="editedItem.pay_commission_id"
                          :items="pay_commission_list" label="Pay Commission/Scale" item-text="name" item-value="id"
                          single-line rounded outlined></v-autocomplete>
                      </v-col>

                      <v-col v-if="editedIndex == -1" cols="12" sm="12" md="12">
                        <v-autocomplete :rules="[(v) => !!v || 'required']" dense v-model="editedItem.designation_id"
                          :items="designation_list" label="Designation" item-text="name" item-value="id" single-line
                          rounded outlined></v-autocomplete>
                      </v-col>
                      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="12">
                        <v-autocomplete :rules="[(v) => !!v || 'required']" dense readonly disabled
                          v-model="editedItem.pay_commission_id" :items="pay_commission_list"
                          label="Pay Commission/Scale" item-text="name" item-value="id" single-line rounded
                          outlined></v-autocomplete>
                      </v-col>

                      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="12">
                        <v-autocomplete :rules="[(v) => !!v || 'required']" dense readonly disabled
                          v-model="editedItem.designation_id" :items="designation_list" label="Designation"
                          item-text="name" item-value="id" single-line rounded outlined></v-autocomplete>
                      </v-col>

                      <!-- <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.pay_band" label="Pay Band" :rules="[v => !!v || 'required']" rounded outlined dense> </v-text-field>
                                            </v-col> -->

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.level" label="Enter Level Number"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.basic_pay" label="Enter Basic Pay"
                          :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.grade_pay" label="Enter Grade Pay" rounded outlined dense
                          type="number">
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- <template>
                    <div class="ml-5 mr-5">
                        <v-row>
                            <v-col>
                                <v-autocomplete dense v-model="editedItem.pay_commission_id" :items="pay_commission_list" label="Pay Commission/Scale" item-text="name" item-value="id" single-line rounded outlined></v-autocomplete>
                            </v-col>

                            <v-col>
                                <v-autocomplete
                                    dense
                                    v-model="editedItem.designation_id"
                                    :items="designation_list"
                                    label="Designation"
                                    item-text="name"
                                    item-value="id"
                                    single-line
                                    rounded
                                    outlined
                                    @change="fetchPayBandDetails()"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </div>
                </template> -->
      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    // extraBreadcrumbItems: [
    //   { text: "Pay Matrix", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    valid: false,
    overlay: false,
    errorMsg: {
      castId: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Pay Commission",
        align: "left",
        sortable: false,
        value: "pay_commission_name",
      },
      {
        text: "Designation",
        align: "left",
        sortable: false,
        value: "designation_name",
      },
      {
        text: "Level",
        align: "left",
        sortable: false,
        value: "level",
      },
      {
        text: "Basic Pay",
        align: "left",
        sortable: false,
        value: "basic_pay",
      },
      {
        text: "Grade Pay",
        align: "left",
        sortable: false,
        value: "grade_pay",
      },
      {
        text: "Is Active?",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      "Pay Commission": "pay_commission_name",
      Designation: "designation_name",
      Level: "level",
      "Basic Pay": "basic_pay",
      "Grade Pay": "grade_pay",
      "Is Active?": "isactive",
    },
    pay_matrix_list: [],
    pay_commission_list: [],
    designation_list: [],
    editedIndex: -1,
    editedItem: {
      payMatrixId: "",
      level: "",
      basic_pay: "",
      grade_pay: "",
      pay_commission_id: "",
      pay_commission_name: "",
      designation_id: "",
      designation_name: "",
      pay_band_id: "",
      pay_band: "",
      isActive: "",
    },
    defaultItem: {
      payMatrixId: "",
      level: "",
      basic_pay: "",
      grade_pay: "",
      pay_commission_id: "",
      pay_commission_name: "",
      designation_id: "",
      designation_name: "",
      pay_band_id: "",
      pay_band: "",
      isActive: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Pay Matrix" : "Edit Pay Matrix";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    fetchPayBandDetails() {
      //window.alert("Function Called")
      if (this.editedItem.pay_commission_id == "") {
        this.showSnackbar("#b71c1c", "Please Select Pay Commission...");
      } else if (this.editedItem.designation_id == "") {
        this.showSnackbar("#b71c1c", "Please Select Designation...");
      } else {
        const data = {
          pay_commission: this.editedItem.pay_commission_id,
          designation: this.editedItem.designation_id,
        };
        this.overlay = true;
        axios
          .post("/Payroll/fetchPayBandDetails", data)
          .then((res) => {
            if (res.data.status.code == "200") {
              this.overlay = false;
              this.pay_band_list = res.data.pay_band_list;
              this.editedItem.pay_band_id = res.data.pay_band_list[0].id;
              this.editedItem.pay_band = res.data.pay_band_list[0].band;
            } else if (res.data.status.code == "NF") {
              this.showSnackbar("#b71c1c", "Please Define Pay Band First"); // show snackbar
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.overlay = false;
          });
      }
    },
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getPayMatrixData")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.pay_commission_list = res.data.pay_commission_list;
              this.designation_list = res.data.designation_list;
              this.pay_matrix_list = res.data.pay_matrix_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.pay_matrix_list.indexOf(item);
      this.dialog = true;
      this.editedItem.level = item.level;
      this.editedItem.basic_pay = item.basic_pay;
      this.editedItem.grade_pay = item.grade_pay;
      this.editedItem.pay_commission_id = item.pay_commission_id;
      this.editedItem.pay_commission_name = item.pay_commission_name;
      this.editedItem.designation_id = item.designation_id;
      this.editedItem.designation_name = item.designation_name;
      this.editedItem.pay_band_id = item.pay_band_id;
      this.editedItem.pay_band = item.band;
      this.editedItem.isActive = item.isactive;
      this.editedItem.payMatrixId = item.id;
      //window.alert(JSON.stringify(this.editedItem))
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      //window.alert("edited Item-->"+JSON.stringify(this.editedItem))
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editPayMatrix", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "200") {
                //   Object.assign(
                //     this.pay_matrix_list[this.editedIndex],
                //     this.editedItem
                //   );
                this.showSnackbar(
                  "#4caf50",
                  "Pay Matrix Updated Successfully..."
                ); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Pay Matrix Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //window.alert(JSON.stringify(this.editedItem))
        axios
          .post("/Payroll/savePayMatrix", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "200") {
              this.showSnackbar("#4caf50", "Pay Matrix Added Successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Pay Matrix Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.payMatrixId) {
        return true;
      } else {
        if (!this.editedItem.payMatrixId) {
          this.errorMsg.payMatrixId = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable2 /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
